import { notificationSettingsApi as api } from './notificationSettingsApi';
export const addTagTypes = ['NotificationSettings'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getNotificationSettings: build.query<
        GetNotificationSettingsApiResponse,
        GetNotificationSettingsApiArg
      >({
        query: queryArg => ({
          url: `/notificationSettings`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['NotificationSettings']
      }),
      addNotificationSettings: build.mutation<
        AddNotificationSettingsApiResponse,
        AddNotificationSettingsApiArg
      >({
        query: queryArg => ({
          url: `/notificationSettings`,
          method: 'POST',
          body: queryArg.notificationSettings
        }),
        invalidatesTags: ['NotificationSettings']
      }),
      getNotificationSettingsById: build.query<
        GetNotificationSettingsByIdApiResponse,
        GetNotificationSettingsByIdApiArg
      >({
        query: queryArg => ({ url: `/notificationSettings/${queryArg.id}` }),
        providesTags: ['NotificationSettings']
      }),
      updateNotificationSettings: build.mutation<
        UpdateNotificationSettingsApiResponse,
        UpdateNotificationSettingsApiArg
      >({
        query: queryArg => ({
          url: `/notificationSettings/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.notificationSettings
        }),
        invalidatesTags: ['NotificationSettings']
      }),
      deleteNotificationSettings: build.mutation<
        DeleteNotificationSettingsApiResponse,
        DeleteNotificationSettingsApiArg
      >({
        query: queryArg => ({
          url: `/notificationSettings/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['NotificationSettings']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetNotificationSettingsApiResponse =
  /** status 200 NotificationSettings found. */ {
    ok?: boolean;
    data?: NotificationSettings;
    message?: string;
  };
export type GetNotificationSettingsApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
};
export type AddNotificationSettingsApiResponse =
  /** status 201 NotificationSettings has been created successfully. */ {
    ok?: boolean;
    data?: NotificationSettings;
    message?: string;
  };
export type AddNotificationSettingsApiArg = {
  /** NotificationSettings that needs to be added to the application */
  notificationSettings: NotificationSettings;
};
export type GetNotificationSettingsByIdApiResponse =
  /** status 200 NotificationSettings details found. */ {
    ok?: boolean;
    data?: NotificationSettings;
    message?: string;
  };
export type GetNotificationSettingsByIdApiArg = {
  /** ID of the NotificationSettings to retrieve */
  id: string;
};
export type UpdateNotificationSettingsApiResponse =
  /** status 200 The NotificationSettings's details has been updated successfully */ {
    ok?: boolean;
    data?: NotificationSettings;
    message?: string;
  };
export type UpdateNotificationSettingsApiArg = {
  /** ID of the NotificationSettings to update */
  id: string;
  /** NotificationSettings that needs to be added to the application */
  notificationSettings: NotificationSettings;
};
export type DeleteNotificationSettingsApiResponse =
  /** status 200 The NotificationSettings's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteNotificationSettingsApiArg = {
  /** ID of the NotificationSettings to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type NotificationSettings = {
  id?: string;
  email?: boolean;
  pushNotification?: boolean;
  newsLetter?: boolean;
};
export const {
  useGetNotificationSettingsQuery,
  useAddNotificationSettingsMutation,
  useGetNotificationSettingsByIdQuery,
  useUpdateNotificationSettingsMutation,
  useDeleteNotificationSettingsMutation
} = injectedRtkApi;
